export default {
    Get: {
        LIST_OF_PROPERTY_VIDEOS: "getListOfPropertyVideos",
        PENDING_VIDEO_UPLOADS: "getPendingVideoUploads"
    },
    Set: {
        LIST_OF_PROPERTY_VIDEOS: "setListOfPropertyVideos",
        INSERT_PROPERTY_VIDEOS: "insertPropertyVideos",
        UPDATE_VIDEO_ENTRY: "updateVideoEntry",
        DELETE_PROPERTY_VIDEO: "deletePropertyVideo",
        QUEUE_PENDING_UPLOAD: "queuePendingVideoUpload",
        CLEAR_PENDING_UPLOADS: "clearPendingVideoUploads",
        ADD_TO_LIST: "addToList",
    }
};
